import { defineMessages } from "react-intl"

// Global / Shared messages should go here
export const messages = defineMessages({
  licenseDescriptionNoKnownRestrictions: {
    id: "license-description.no_known_restrictions",
    defaultMessage:
      "There are no known restrictions on this work. You can copy, modify, distribute and perform the work, even for commercial purposes, all without asking permission."
  },
  licenseDescriptionSomeRestrictionsMayApply: {
    id: "license-description.some_restrictions_apply",
    defaultMessage:
      "There may be some restrictions on reusing this work. Please [contact us](mailto:{email}) for details."
  },
  licenseDescriptionContactUsForDetails: {
    id: "license-description.contact_us",
    defaultMessage:
      "This work is under copyright. Please [contact us](mailto:{email}) for details on licensing this work."
  },
  licenseDescriptionAttributionShareAlike: {
    id: "license-description.cc-by-sa",
    defaultMessage:
      "ShareAlike — If you remix, transform, or build upon the material, you must distribute your contributions under the same license as the original."
  },
  licenseDescriptionPublicDomainDedication: {
    id: "license-description.cc0",
    defaultMessage:
      "You can copy, modify, distribute and perform the work, even for commercial purposes, all without asking permission."
  },
  licenseNoKnownRestrictions: {
    id: "license.no_known_restrictions",
    defaultMessage: "No Known Restrictions"
  },
  licenseNoKnownCopyright: {
    id: "license.no_known_copyright",
    defaultMessage: "No Known copyright"
  },
  licenseSomeRestrictionsMayApply: {
    id: "license.some_restrictions_apply",
    defaultMessage: "Some Restrictions May Apply"
  },
  licenseContactUsForDetails: {
    id: "license.contact_us",
    defaultMessage: "Contact Us For Details"
  },
  licenseCopyright: {
    id: "license.copyright",
    defaultMessage: "Copyright"
  },
  licenseByAttributionAlone: {
    id: "license.cc-by",
    defaultMessage: "By Attribution Alone"
  },
  licenseAttributionShareAlike: {
    id: "license.cc-by-sa",
    defaultMessage: "Attribution + ShareAlike"
  },
  licenseAttributionNoDerivatives: {
    id: "license.cc-by-nd",
    defaultMessage: "Attribution + NoDerivatives"
  },
  licenseAttributionNonCommercial: {
    id: "license.cc-by-nc",
    defaultMessage: "Attribution + NonCommercial"
  },
  licenseAttributionNonCommercialShareAlike: {
    id: "license.cc-by-nc-sa",
    defaultMessage: "Attribution + NonCommercial + ShareAlike"
  },
  licenseAttributionNonCommercialNoDerivatives: {
    id: "license.cc-by-nc-nd",
    defaultMessage: "Attribution + NonCommercial + NoDerivatives"
  },
  licensePublicDomainDedication: {
    id: "license.cc0",
    defaultMessage: "Public Domain Dedication"
  },
  licenseDefinitionAdaptC: {
    id: "license-definition.adapt-c",
    defaultMessage:
      "Remix, transform, and build upon the material for any purpose, even commercially."
  },
  licenseAdaptC: {
    id: "license.adapt-c",
    defaultMessage: "Adapt"
  },
  licenseDefinitionAdapt: {
    id: "license-definition.adapt",
    defaultMessage: "Remix, transform, and build upon the material"
  },
  licenseAdapt: {
    id: "license.adapt",
    defaultMessage: "Adapt"
  },
  licenseDefinitionAttribution: {
    id: "license-definition.attribution",
    defaultMessage:
      "You must give appropriate credit, provide a link to the license, and indicate if changes were made. You may do so in any reasonable manner, but not in any way that suggests the licensor endorses you or your use."
  },
  licenseAttribution: {
    id: "license.attribution",
    defaultMessage: "Attribution"
  },
  licenseDefinitionNoAdditional: {
    id: "license-definition.no-additional",
    defaultMessage:
      "You may not apply legal terms or technological measures that legally restrict others from doing anything the license permits."
  },
  licenseNoAdditional: {
    id: "license.no-additional",
    defaultMessage: "No additional restrictions"
  },
  licenseDefinitionNoDerivatives: {
    id: "license-definition.no-derivatives",
    defaultMessage:
      "If you remix, transform, or build upon the material, you may not distribute the modified material."
  },
  licenseNoDerivatives: {
    id: "license.no-derivatives",
    defaultMessage: "NoDerivatives"
  },
  licenseDefinitionNonCommercial: {
    id: "license-definition.non-commercial",
    defaultMessage: "You may not use the material for commercial purposes."
  },
  licenseNonCommercial: {
    id: "license.non-commercial",
    defaultMessage: "NonCommercial"
  },
  licenseDefinitionContact: {
    id: "license-definition.contact",
    defaultMessage:
      "Please [contact us](mailto:{email}) for details on licensing this work."
  },
  licenseContact: {
    id: "license.contact",
    defaultMessage: "Contact"
  },
  licenseDefinitionShareNC: {
    id: "license-definition.share-nc",
    defaultMessage: "Copy and redistribute the material in any medium or format"
  },
  licenseShareNC: {
    id: "license.share-nc",
    defaultMessage: "Share"
  },
  licenseDefinitionShare: {
    id: "license-definition.share",
    defaultMessage:
      "Copy and redistribute the material in any medium or format for any purpose, even commercially."
  },
  licenseShare: {
    id: "license.share",
    defaultMessage: "Share"
  },
  fullCredit: {
    id: "license-message.full-credit",
    defaultMessage: "Full credit for this"
  },
  createCommonsAttributeLicense: {
    id: "license.creative-commons-attribute-license",
    defaultMessage: "Creative Commons Attribution License (CC-BY)"
  }
})



// WEBPACK FOOTER //
// ./webapp/messages/licenses.js